import $ from 'jquery';

export default function avuNavFooter() {
    $('.nav-item.open-avu-problems-messages-modal').on('click', function(event) {
        event.preventDefault();
    });
    $('.nav-item.open-avu-messages-modal').on('click', function(event) {
        event.preventDefault();
    });
}